import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {getUserIsAuthenticated} from '../_selectors/user';
import {connect} from 'react-redux';

type PrivateRouteProps = {
    children: any;
    isAuthenticated: boolean;
    path?: string;
};
const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
                                                                      children,
                                                                      isAuthenticated,
                                                                      ...rest
                                                                  }) => {
    return (
        <Route
            {...rest}
            render={({location}: any) =>
                isAuthenticated ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
};

const mapStateToProps = (state: any) => ({
    isAuthenticated: getUserIsAuthenticated(state),
});

const ConnectedPrivateRoute = connect(mapStateToProps)(PrivateRoute);
export {ConnectedPrivateRoute as PrivateRoute};
